import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Checkbox, Radio} from 'react-icheck';
import 'icheck/skins/all.css';
import moment from 'moment';


import {manageCourse} from '../../data/manageCourse'

const studentsAmountMax = 50;

class InPersonSession extends Component {


    render() {
        return (
            <div className="content-wrapper" id="content-container">

                <section className="content">
                    <div className="row">
                        <div className="col-sm-12">

                            <div className="panel customPanel">
                                <div className="panel-heading">
                                    <h3 className="panel-title">
                                        Responses
                                    </h3>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

InPersonSession.propTypes = {
    students: PropTypes.array,
};



export default InPersonSession;


// WEBPACK FOOTER //
// ./src/components/UserCourse/InPersonSession.js